import React, { useState, useEffect } from "react";
import { Icon, Button } from "semantic-ui-react";
import {
  Field,
  Label,
  InputText,
  InputLabel,
} from "../../../../../pages/Admin/Empresas/criarEmpresas/styled";

import Dropzone from "../../../../../components/Admin/Dropzone";

const Informacoes = (props) => {
  const [selectedFile, setSelectedFile] = useState("");
  const [empresa, setEmpresa] = useState(props.valor);

  const handleValue = async (e) => {
    setSelectedFile(e);
    props.handleInfo({ file: e, nome: empresa.nome, url: empresa.url });
  };

  return (
    <>
      <Field>
        <Label>Nome da Empresa</Label>
        <InputText
          type="text"
          placeholder="Nome da empresa"
          value={empresa.nome}
          onChange={(e) =>
            setEmpresa({ ...empresa, nome: e.target.value, file: selectedFile })
          }
        />
      </Field>
      <Field>
        <Label>Url do Portal</Label>
        <InputLabel
          label="https://www.voitto.com.br/online/"
          placeholder="portal-..."
          value={empresa.url}
          onChange={(e) =>
            setEmpresa({ ...empresa, url: e.target.value, file: selectedFile })
          }
        />
      </Field>
      <Field>
        <Label>Logo da empresa</Label>
        <Dropzone onFileUploaded={(e) => handleValue(e)} />
      </Field>
    </>
  );
};

export default Informacoes;
